import type { OutreachRow } from '@discovr/types';
import { isWithBrandStatus } from '@discovr/types';
import { hasRateToHandOff, isCreatorTold } from './handoffStates';
import { fmtAgreedTotal } from './agreedMoney';
import { PILL_AMBER, PILL_GREEN, PILL_RED } from './pillPalette';

export interface BrandPill {
  label: string;
  cls: string;
}

const EMERALD = PILL_GREEN;
export const AMBER_PILL = PILL_AMBER;
export const ROSE_PILL = PILL_RED;

/** The with-brand pill vocabulary (D8). Null leaves the row to OutreachStatusPill (incl. "Rate locked"). */
export function brandStatePill(row: Pick<OutreachRow, 'status' | 'brandState' | 'confirmedAt' | 'brandDecidedAt' | 'lastMessage'>): BrandPill | null {
  if (!isWithBrandStatus(row.status)) return null;
  switch (row.brandState ?? 'none') {
    case 'approved':
      if (row.status !== 'accepted_by_brand') return { label: 'Brand approved', cls: EMERALD };
      return { label: isCreatorTold(row) ? 'Brand approved · creator told' : 'Brand approved · tell the creator', cls: EMERALD };
    case 'counter_requested':
      return { label: 'Brand asked for less', cls: AMBER_PILL };
    case 'rejected':
      return { label: 'Brand declined', cls: ROSE_PILL };
    case 'pending':
      return { label: 'With brand · Pending', cls: EMERALD };
    default:
      return null;
  }
}

export function agreedAmountLabel(row: Pick<OutreachRow, 'status' | 'outreachState' | 'agreedDeliverables' | 'agreedMoney'>): string | null {
  if (!hasRateToHandOff(row) && !isWithBrandStatus(row.status)) return null;
  if (!row.agreedDeliverables?.length) return null;
  return fmtAgreedTotal(row.agreedMoney);
}
